import React from 'react';

import styles from './styles.module.scss';

interface IFormContainerProps {
  children: React.ReactNode,
  title: string,
}

const FormContainer = ({
  children,
  title,
}: IFormContainerProps) => (
  <div className={styles.container}>
    <h1>
      {title}
    </h1>
    {children}
  </div>
);

export default FormContainer;
